<div class="profile-container" *ngIf="!loading && userProfile">
  
  <div class="dash-header">
    <h1 class="cyber-title">>_ MI PERFIL</h1>
    <p class="subtitle">Gestiona tus preferencias, credenciales y monitoriza tu consumo.</p>
  </div>

  <div class="profile-grid">
    
    <div class="left-column">
      
      <div class="surface profile-card">
        <h3 class="card-title">>_ INFORMACIÓN PERSONAL</h3>
        
        <div class="readonly-info" style="display: flex; flex-wrap: wrap; gap: 30px; margin-bottom: 15px; padding-bottom: 15px; border-bottom: 1px solid rgba(255,255,255,0.1);">
          <div class="info-group" style="margin-bottom: 0;">
            <label>USUARIO DE ACCESO</label>
            <span class="value">{{ userProfile.username }} ({{ userProfile.email }})</span>
          </div>
          <div class="info-group" style="margin-bottom: 0;">
            <label>EMPRESA / ENTORNO</label>
            <span class="value highlight" *ngIf="userProfile.tenant">{{ userProfile.tenant.name }}</span>
            <span class="value" *ngIf="!userProfile.tenant">MODO GLOBAL (Sistema)</span>
          </div>
        </div>

        <form [formGroup]="profileForm" (ngSubmit)="saveProfile()">
          <div style="display: flex; gap: 15px; margin-bottom: 10px;">
            <div style="flex: 1;">
              <label class="modal-label">Nombre</label>
              <input type="text" class="form-control form-control-sm" formControlName="nombre" placeholder="Tu nombre...">
            </div>
            <div style="flex: 1;">
              <label class="modal-label">Apellidos</label>
              <input type="text" class="form-control form-control-sm" formControlName="apellidos" placeholder="Tus apellidos...">
            </div>
          </div>

          <div style="display: flex; gap: 15px; margin-bottom: 15px;">
            <div style="flex: 1;">
              <label class="modal-label">Idioma</label>
              <select class="form-control form-control-sm" formControlName="idioma">
                <option value="es">Español</option>
                <option value="en">English</option>
              </select>
            </div>
            <div style="flex: 1;">
              <label class="modal-label">Zona Horaria</label>
              <select class="form-control form-control-sm" formControlName="timezone">
                <option value="Europe/Madrid">Europe/Madrid (CET)</option>
                <option value="America/Bogota">America/Bogota (COT)</option>
                <option value="America/Mexico_City">America/Mexico_City (CST)</option>
              </select>
            </div>
          </div>

          <div style="text-align: right;">
            <button type="submit" class="btn primary sm" [disabled]="isSaving || profileForm.pristine">
              GUARDAR PREFERENCIAS
            </button>
          </div>
        </form>
      </div>

      <div class="surface profile-card">
        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 15px;">
          <div>
            <h3 class="card-title" style="margin-bottom: 5px;">>_ SEGURIDAD Y CREDENCIALES</h3>
            <p style="font-size: 11px; color: var(--dl-color-theme-neutral-dark); margin: 0;">
              Requiere la contraseña actual por motivos de seguridad.
            </p>
          </div>
        </div>

        <form [formGroup]="passwordForm" (ngSubmit)="changePassword()">
          <div style="margin-bottom: 10px; max-width: 50%;">
            <label class="modal-label">Contraseña Actual</label>
            <input type="password" class="form-control form-control-sm" formControlName="currentPassword">
          </div>
          
          <div style="display: flex; gap: 15px; margin-bottom: 10px;">
            <div style="flex: 1;">
              <label class="modal-label">Nueva Contraseña</label>
              <input type="password" class="form-control form-control-sm" formControlName="newPassword">
            </div>
            <div style="flex: 1;">
              <label class="modal-label">Confirmar Contraseña</label>
              <input type="password" class="form-control form-control-sm" formControlName="confirmPassword">
            </div>
          </div>
          
          <div *ngIf="passwordForm.errors?.['mismatch'] && passwordForm.get('confirmPassword')?.touched" style="color: #ff5f56; font-size: 11px; margin-bottom: 10px; font-family: monospace;">
            * Las contraseñas nuevas no coinciden.
          </div>

          <div style="text-align: right; margin-top: 10px;">
            <button type="submit" class="btn danger sm" [disabled]="passwordForm.invalid">
              ACTUALIZAR CONTRASEÑA
            </button>
          </div>
        </form>
      </div>

    </div>

    <div class="right-column">
      <div class="surface profile-card neon-box">
        <h3 class="card-title">>_ CONSUMO DE IA (RAG)</h3>
        
        <div class="token-monitor">
          <div class="token-circle" [style.background]="'conic-gradient(' + (tokenPercentage > 90 ? '#ff5f56' : (tokenPercentage > 70 ? '#ffbd2e' : '#a6e22e')) + ' ' + tokenPercentage + '%, rgba(255,255,255,0.05) 0)'">
            <div class="inner-circle">
              <span class="pct">{{ tokenPercentage }}%</span>
            </div>
          </div>
          
          <div class="token-stats">
            <div class="stat">
              <label>CONSUMIDOS</label>
              <span>{{ userProfile.consumedtokens | number }}</span>
            </div>
            <div class="stat divider">/</div>
            <div class="stat">
              <label>LÍMITE ASIGNADO</label>
              <span>{{ userProfile.totaltokens | number }}</span>
            </div>
          </div>
        </div>

        <p class="token-warning" *ngIf="tokenPercentage >= 100">
          ⚠️ LÍMITE DE TOKENS ALCANZADO.
        </p>

      </div>
    </div>
  </div>
</div>